// Minimal JWT payload decoder for the browser — we only ever need one claim ("sid") out of an
// already-trusted token issued by our own backend, not a verifying JWT library.
const decodeJwtPayload = (token: string): Record<string, any> | null => {
  try {
    const parts = token.split(".");
    if (parts.length !== 3) return null;

    const base64 = parts[1].replace(/-/g, "+").replace(/_/g, "/");
    const padded = base64 + "=".repeat((4 - (base64.length % 4)) % 4);
    const decoded = atob(padded);
    const jsonString = decodeURIComponent(
      decoded
        .split("")
        .map((c) => "%" + c.charCodeAt(0).toString(16).padStart(2, "0"))
        .join("")
    );
    return JSON.parse(jsonString);
  } catch {
    return null;
  }
};

// The "sid" claim identifies which UserSession row (backend) this specific token belongs to —
// see Models/Entities/UserSession.cs. A token issued before the session-management rollout has
// no "sid" at all; callers should treat null as "can't compare, don't react" rather than a match.
export const getSessionIdFromToken = (token: string | null | undefined): string | null => {
  if (!token) return null;
  const payload = decodeJwtPayload(token.replace(/(^"|"$)/g, ""));
  return payload?.sid ?? null;
};
